import __var_0__ from '@stdlib/random/base/minstd';
import __var_1__ from '@stdlib/random/base/minstd-shuffle';
import __var_2__ from '@stdlib/random/base/mt19937';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

var prngs = {};

prngs[ 'minstd' ] = __var_0__;
prngs[ 'minstd-shuffle' ] = __var_1__;
prngs[ 'mt19937' ] = __var_2__;


// EXPORTS //
export default prngs;
